import React, { useEffect, useState } from 'react';
import UserService from '../../services/UserService';
import ViewPdf from '../../pages/instructor/ViewPdf';
import service, { URI } from '../../services/service';
import swal from 'sweetalert';

export const TokenImage = ({ path }) => {
  const token = UserService.getToken();
  const [imgSrc, setImgSrc] = useState('');

  useEffect(() => {
    const fetchImage = async () => {
      const url = `${URI.SERVER._USER_API}api/getprofilepicforadminverification/${path}`;
      try {
        const response = await fetch(url, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const contentLength = response.headers.get('Content-Length');
        if (contentLength == 0) {
          await swal("Information", "File not available", "info");
        }

        const blob = await response.blob();
        const imgUrl = URL.createObjectURL(blob);
        setImgSrc(imgUrl);
      } catch (error) {
      }
    };

    fetchImage();
  }, [path, token]);

  return (
    <img
      src={imgSrc}
      alt="Profile"
      style={{ width: '42px', height: '42px', borderRadius: '100%', boxShadow: "5px 10px 20px 1px rgba(0, 0, 0, 0.253)" }}
    />
  );
};


export const TokenImageinModel = ({ path }) => {
  const token = UserService.getToken();
  const [imgSrc, setImgSrc] = useState('');

  useEffect(() => {
    const fetchImage = async () => {
      const url = `${URI.SERVER._USER_API}api/getprofilepicforadminverification/${path}`;
      try {

        //console.log("path ===>", path);


        if (path) {

          const response = await fetch(url, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });

          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          const contentLength = response.headers.get('Content-Length');
          if (contentLength == 0) {
            await swal("Information", "File not available", "info");
          }

          const blob = await response.blob();
          const imgUrl = URL.createObjectURL(blob);
          setImgSrc(imgUrl);
        }
      } catch (error) {
      }
    };

    fetchImage();
  }, [path, token]);

  return (
    <img
      src={imgSrc}
      alt="Profile"
      style={{ width: '100%' }}
    />
  );
};

export const TokenIDImageinModel = ({ path }) => {
  const token = UserService.getToken();
  const [imgSrc, setImgSrc] = useState('');
  const [pdfSrc, setPdfSrc] = useState('');
  const [getContentType, setContentType] = useState();

  useEffect(() => {
    const fetchImage = async () => {
      const url = `${URI.SERVER._USER_API}api/getidforadminverification/${path}`;
      try {
        const response = await fetch(url, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const contentLength = response.headers.get('Content-Length');
        const contentType = response.headers.get('Content-Type');
        setContentType(contentType);


        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        if (contentLength == 0) {
          await swal("Information", "File not available", "info");
        }

        if (contentType == "image/jpeg" || contentType == "image/jpg" || contentType == "image/png") {

          const blob = await response.blob();
          const imgUrl = URL.createObjectURL(blob);
          setImgSrc(imgUrl);

        } else if (contentType === "application/pdf") {
          const blob = await response.blob();
          const pdfUrl = URL.createObjectURL(blob);
          setPdfSrc(pdfUrl);
        }


      } catch (error) {
      }
    };

    fetchImage();
  }, [path, token]);

  return (
    <>
      {(getContentType == "image/jpeg" || getContentType == "image/jpg" || getContentType == "image/png") && (<img
        src={imgSrc}
        alt="Profile"
        style={{ width: '100%' }}
      />)}
      {getContentType === "application/pdf" && (
        <ViewPdf
          pdfUrl={pdfSrc}
        />

      )}
    </>

  );
};


export const TokenCertificateImageinModel = ({ path }) => {
  const token = UserService.getToken();
  const [imgSrc, setImgSrc] = useState('');
  const [pdfSrc, setPdfSrc] = useState('');
  const [getContentType, setContentType] = useState();

  useEffect(() => {
    const fetchImage = async () => {
      const url = `${URI.SERVER._USER_API}api/getcertificateforadminverification/${path}`;
      try {
        const response = await fetch(url, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const contentType = response.headers.get('Content-Type');
        setContentType(contentType);


        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const contentLength = response.headers.get('Content-Length');
        if (contentLength == 0) {
          await swal("Information", "File not available", "info");
        }

        if (contentType == "image/jpeg" || contentType == "image/jpg" || contentType == "image/png") {

          const blob = await response.blob();
          const imgUrl = URL.createObjectURL(blob);
          setImgSrc(imgUrl);

        } else if (contentType === "application/pdf") {
          const blob = await response.blob();
          const pdfUrl = URL.createObjectURL(blob);
          setPdfSrc(pdfUrl);
        }
      } catch (error) {
      }
    };

    fetchImage();
  }, [path, token]);

  return (
    <>
      {(getContentType == "image/jpeg" || getContentType == "image/jpg" || getContentType == "image/png") && (<img
        src={imgSrc}
        alt="Profile"
        style={{ width: '100%' }}
      />)}
      {getContentType === "application/pdf" && (
        <ViewPdf
          pdfUrl={pdfSrc}
        />

      )}
    </>
  );
};

//--------------------------------------------------------------------------------------------------------------------------------
//     Profile update Modal Images
//--------------------------------------------------------------------------------------------------------------------------------

export const TokenImageForProfileUpdate = ({ path }) => {
  const token = UserService.getToken();
  const [imgSrc, setImgSrc] = useState('');

  useEffect(() => {
    const fetchImage = async () => {
      const url = `${URI.SERVER._USER_API}api/getprofilepicforprofileupdate/${path}`;
      try {

        //console.log("path ===>", path);


        if (path) {

          const response = await fetch(url, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });

          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          const contentLength = response.headers.get('Content-Length');
          if (contentLength == 0) {
            await swal("Information", "File not available", "info");
          }

          const blob = await response.blob();
          const imgUrl = URL.createObjectURL(blob);
          setImgSrc(imgUrl);
        }
      } catch (error) {
      }
    };

    fetchImage();
  }, [path, token]);

  return (
    <img
      src={imgSrc}
      alt="Profile"
      style={{ width: '100%' }}
    />
  );
};

export const TokenIDImageForProfileUpdate = ({ path }) => {
  const token = UserService.getToken();
  const [imgSrc, setImgSrc] = useState('');
  const [pdfSrc, setPdfSrc] = useState('');
  const [getContentType, setContentType] = useState();

  useEffect(() => {
    const fetchImage = async () => {
      const url = `${URI.SERVER._USER_API}api/getidforprofileupdate/${path}`;
      try {
        const response = await fetch(url, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const contentLength = response.headers.get('Content-Length');
        const contentType = response.headers.get('Content-Type');
        setContentType(contentType);


        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        if (contentLength == 0) {
          await swal("Information", "File not available", "info");
        }

        if (contentType == "image/jpeg" || contentType == "image/jpg" || contentType == "image/png") {

          const blob = await response.blob();
          const imgUrl = URL.createObjectURL(blob);
          setImgSrc(imgUrl);

        } else if (contentType === "application/pdf") {
          const blob = await response.blob();
          const pdfUrl = URL.createObjectURL(blob);
          setPdfSrc(pdfUrl);
        }


      } catch (error) {
      }
    };

    fetchImage();
  }, [path, token]);

  return (
    <>
      {(getContentType == "image/jpeg" || getContentType == "image/jpg" || getContentType == "image/png") && (<img
        src={imgSrc}
        alt="Profile"
        style={{ width: '100%' }}
      />)}
      {getContentType === "application/pdf" && (
        <ViewPdf
          pdfUrl={pdfSrc}
        />

      )}
    </>

  );
};


export const TokenCertificateImageForProfileUpdate = ({ path }) => {
  const token = UserService.getToken();
  const [imgSrc, setImgSrc] = useState('');
  const [pdfSrc, setPdfSrc] = useState('');
  const [getContentType, setContentType] = useState();

  useEffect(() => {
    const fetchImage = async () => {
      const url = `${URI.SERVER._USER_API}api/getcertificateforprofileupdate/${path}`;
      try {
        const response = await fetch(url, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const contentType = response.headers.get('Content-Type');
        setContentType(contentType);


        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const contentLength = response.headers.get('Content-Length');
        if (contentLength == 0) {
          await swal("Information", "File not available", "info");
        }

        if (contentType == "image/jpeg" || contentType == "image/jpg" || contentType == "image/png") {

          const blob = await response.blob();
          const imgUrl = URL.createObjectURL(blob);
          setImgSrc(imgUrl);

        } else if (contentType === "application/pdf") {
          const blob = await response.blob();
          const pdfUrl = URL.createObjectURL(blob);
          setPdfSrc(pdfUrl);
        }
      } catch (error) {
      }
    };

    fetchImage();
  }, [path, token]);

  return (
    <>
      {(getContentType == "image/jpeg" || getContentType == "image/jpg" || getContentType == "image/png") && (<img
        src={imgSrc}
        alt="Profile"
        style={{ width: '100%' }}
      />)}
      {getContentType === "application/pdf" && (
        <ViewPdf
          pdfUrl={pdfSrc}
        />

      )}
    </>
  );
};

